import { makeAutoObservable } from "mobx";
import axios from "axios";
import { onMessage, isSupported } from "firebase/messaging";
import { fMessaging } from "../firebase";

export interface Tournament {
  id: string;
  title: string;
  timestamp: string;
  type: "Gaming" | "Quiz" | "Snooker" | any;
  TournamentTypeId: string;
}

export type TournamentTab = "Log" | "Details" | "Results" | "Update";

class TournamentStore {
  tournaments: Tournament[] = [];
  focusedTournament: Tournament | null = null;
  openedTab: number = 0;
  loadingTournaments = false;
  isWordTable = false;

  constructor() {
    makeAutoObservable(this);
    this.preLoad();
    isSupported()
      .then((v) => {
        if (v) {
          console.log("Firebase Messaging SUPPORTED");
          onMessage(fMessaging, (message) => {
            console.log(message);
          });
        } else {
          console.log("Firebase Messaging not supported by browser");
        }
      })
      .catch((r) => {
        console.warn(r);
      });
  }

  public preLoad(type: number = 0) {
    this.loadingTournaments = true;
    axios
      .get("https://wallof-backend.uc.r.appspot.com/tournaments/" + type)
      .then((r) => {
        const officialTournaments = r.data as unknown as any;
        const list = new Array<Tournament>();
        list.push({
          id: "overview",
          timestamp: new Date().getTime().toString(),
          title: "Overview",
          type: "Overview",
          TournamentTypeId: "overview",
        });
        (officialTournaments["official"] as Tournament[]).forEach((t) =>
          list.push(t)
        );
        this.tournaments = list;
        if (this.tournaments.length > 0)
          // this.tournaments.
          this.selectTournament(this.tournaments[0]);
        console.log(list);
        this.loadingTournaments = false;
      })
      .catch((e) => {
        console.error(e);
        this.loadingTournaments = false;
      });
  }

  public selectTournament(t: Tournament) {
    this.focusedTournament = t;
    this.isWordTable =
      t.TournamentTypeId === "c5e91f3f-e7bd-11f0-9bd3-0a67fa16b369";
    console.log(this.isWordTable ? "Word Table" : "Gaming League");
  }

  public switchTab(index: number) {
    this.openedTab = index;
  }
}

const tournamentStore = new TournamentStore();

export { tournamentStore };
